import { Injectable } from "@angular/core";
import { TermDataModel, TermViewModel } from "../../shared/models/term.model";
import { CoreLogService } from "../../services/log.service";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { ContentType } from "../../shared/contentTypes";
import { IObjectObserver } from "../../services/IObjectObserver";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";

@Injectable({
  providedIn: "root"
})
export class TermDialogService {
  private _termObsServ: IObjectObserver<TermDataModel>;

  constructor(private objObsInjectHelper: CircularInjectionHelper,
    private _coreLogService: CoreLogService) {
    this._termObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<TermDataModel>(ContentType.Term, objObsInjectHelper);
  }

  /**
   * Getting the list of Impressum and Term DataModel
   * Create ImpressumTermViewmodel
   * @result return a promise that resolves a data of ImpressumTermViewModel
   */
  public GetTermViewModelBuId(id: number): Promise<TermViewModel> {
    const me = this;
    let termViewModel: TermViewModel = new TermViewModel();
    return new Promise<TermViewModel>((resolve, reject) => {
      me._termObsServ.GetObject(id)
        .then((terms) => {
          termViewModel = me.mapTermDataModelToViewModel(terms);
          resolve(termViewModel);
        })
        .catch(reject);
    });
  }

  public get TermObserveChanges(): Observable<(string | number)[]> {
    return this._termObsServ.ObserveChanges;
  }

  // Mapper

  /**
   * map a TermDataModel to TermViewModel
   * @param model Get a TermDataModel for mapping
   * @result return a TermViewModel
   */
  private mapTermDataModelToViewModel(model: TermDataModel): TermViewModel {
    const me = this;
    const viewModel = new TermViewModel();
    viewModel.id = model.id;
    viewModel.sort_nr = model.sort_nr;
    viewModel.label_de = model.label_de;
    viewModel.label_en = model.label_en;
    viewModel.text_html_de = model.text_html_de;
    viewModel.text_html_en = model.text_html_en;
    return viewModel;
  }

}
